import useSWR from "swr";
import actionsService from "../../services/actions.service";
import { Action } from "../../types/Action";

const useAction = (actionId?: string | number) => {
    const { data, error, isLoading, mutate } = useSWR(`action/${actionId}`, actionId ? () => actionsService.getAction(actionId) : null, {
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        refreshWhenHidden: false,
        refreshWhenOffline: false,
    });

    const action = data?.data;

    const mutateAction = (newActionData: Action, options = {}) => {
        mutate(
            (actionData) => ({
                ...actionData,
                data: { ...newActionData },
            }),
            options
        );
    };

    return {
        action,
        isLoading: isLoading || !action,
        error,
        mutateAction,
    };
};

export default useAction;
